import React from 'react';
import { useStyletron } from 'baseui';
import { Button, KIND as BUTTON_KIND } from 'baseui/button';
const buttonOverrides = {
  BaseButton: {
    style: {
      width: '100%'
    }
  }
};
interface EditActionSectionProps {
  onPrimaryAction: () => void;
  onSecondaryAction?: () => void;
  primaryActionLabel: string;
  secondaryActionLabel?: string;
  isPrimaryLoading?: boolean;
  isPrimaryDisabled?: boolean;
}
export const EditActionSection = ({
  onPrimaryAction,
  onSecondaryAction,
  primaryActionLabel,
  secondaryActionLabel,
  isPrimaryLoading = false,
  isPrimaryDisabled = false
}: EditActionSectionProps) => {
  const [css, theme] = useStyletron();
  return <div className={css({
    display: 'flex',
    gap: theme.sizing.scale400,
    justifyContent: 'space-between',
    position: 'sticky',
    bottom: theme.sizing.scale400,
    backgroundColor: theme.colors.backgroundPrimary,
    padding: theme.sizing.scale400,
    boxShadow: theme.lighting.shallowAbove,
    borderRadius: theme.borders.radius300
  })}>
      {secondaryActionLabel && <Button kind={BUTTON_KIND.tertiary} overrides={buttonOverrides} onClick={onSecondaryAction}>
          {secondaryActionLabel}
        </Button>}
      <Button overrides={buttonOverrides} onClick={onPrimaryAction} isLoading={isPrimaryLoading} disabled={isPrimaryDisabled || isPrimaryLoading}>
        {primaryActionLabel}
      </Button>
    </div>;
};